module.exports = __webpack_public_path__ + "static/media/videocamera.9d108762.svg";